import DashboardTabComp from '../../components/DashboardComponents/DashboardTabComp';
// import DashboardDropdown from '../../components/DashboardComponents/DashboardDropDown';
import UserProductionDashboardComp from '../../components/pagecomponents/DashboardComp/UserLevelDashboard/UserProductionDashboardComp';
import ProductionData from '../../Data/DashboardData/UserLevelDBProductionData.json';
import { useState } from 'react';

// import UserLevelCompliance from '../../components/pagecomponents/DashboardComp/UserLevelDashboard/UserLevelCompliance';

import UserLevelQualityDashboards from '../../components/pagecomponents/DashboardComp/UserLevelDashboard/UserLevelDashboards';
import { IconAnalyze, IconListCheck, IconStar } from '@tabler/icons-react';
function UserLevelMainTab() {
  const [activeTab, setActiveTab] = useState(0); // State to track active tab

  const tabs = [
    {
      label: 'Production',
      icon: IconAnalyze,
      header: '',
      component: <UserProductionDashboardComp />,
      data: ProductionData,
    },
    {
      label: 'Quality',
      icon: IconStar,
      header: '',
      component: <UserLevelQualityDashboards />,
      data: '',
    },
    // {
    //   label: 'Compliance',
    //   icon: IconListCheck,
    //   header: 'Uploaded & Allocated Summary',
    //   component: <UserLevelCompliance />,
    //   data: '',
    // },
  ];
  return (
    <>
      {/* <DashboardDropdown /> */}
      <DashboardTabComp
        tabs={tabs}
        activeTab={activeTab} // Pass activeTab to manage which tab is selected
        onTabChange={setActiveTab} // Pass setActiveTab to update activeTab state
        data={tabs[activeTab]?.data} // Pass data of the currently active tab
      />
    </>
  );
}
export default UserLevelMainTab;
